<template>
  <nav class="user-info__menu">
    <ui-logo :target="'domain'" :is-logo-white="false"/>
    <ul  class="menu-list" :class="{ab: isABPlan}">
      <li :class="[item.name,'list']" v-for="(item, index) in MenuList" :key="`user-info-${index}`">
        <router-link class="item" :class="{on: item.name === routeName}" :to="{name: `${item.name}`}">{{ $t(`userInfo.lnb.${item.name}`) }}</router-link>
        <template v-for="(sub, idx) in item.list">
          <router-link class="sub-list" :key="`user-info-sub${idx}`"
               :class="{on: sub.name === routeName}"
               :to="{name: `${sub.name}`}">
              {{ $t(`userInfo.lnb.${sub.name}`) }}
          </router-link>
        </template>
      </li>
    </ul>
    <ui-button class="btn__coupon" :iconName="'icon--coupon'" @click="showCouponLayer">{{ $t('userInfo.coupon.button') }}</ui-button>
  </nav>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import { mapState } from 'vuex'
import UiLogo from '@/components/ui/UiLogo.vue'

export default {
  components: {
    UiButton,
    UiLogo
  },
  props: [
    'routeName'
  ],
  data () {
    return {
      MenuList: [
        { name: 'managePlan' },
        { name: 'billing' },
        { name: 'ipBlocking' },
        { name: 'jam' },
        { name: 'myInformation', list: [{ name: 'referrals' }] }
      ]
    }
  },
  computed: {
    ...mapState([
      'applyData',
      'isABPlan'
    ])
  },
  methods: {
    showCouponLayer () {
      this.$emit('showCouponLayer')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info__menu {
  .menu-list {
    position: absolute;
    top: 134px;
    width: 210px;

    .list:first-child .item {
      border-top: 1px solid #ebebeb;
    }

    .list {
      border-bottom: 1px solid #ebebeb;

      &.ipBlocking {
        border-bottom: none;
        position: relative;
        padding-bottom: 6px;

        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 4px;
          border-top:1px solid #E0E0E0;
          border-bottom:1px solid #E0E0E0;
          background-color: #F4F4F4;
        }
      }
    }

    .sub-list {
      display: inline-block;
      font-size: 13px;
      padding: 0px 18px 15px 12px;
      cursor: pointer;
      font-weight: 400;
      color: #2f2f2f;

      &.on {
        color: $brandColor;
      }

      &::before {
        content: "•";
        color: #999999;
      }
    }

    .item {
      display: block;
      padding: 18px 12px;
      font-size: 13px;
      font-weight: 500;
      color: #2f2f2f;

      &.on {
        color: $brandColor;
      }
    }
    &.ab {

    }
  }
  .btn__coupon {
    width: 186px;
    height: 38px;
    border-radius: 20px;
    border: solid 1px #bbbbbb;
    background-color: #ffffff;
    position: absolute;
    left: 12px;
    bottom: 12px;
    text-align: right;

    /deep/ .icon {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
    }
  }
}
</style>
